// Bikes — non-selected (by battery)
import bikeBat10 from '../../../assets/images/mapImages/Markers/bikes/non-selected/bat_10.svg'
import bikeBat25 from '../../../assets/images/mapImages/Markers/bikes/non-selected/bat_25.svg'
import bikeBat40 from '../../../assets/images/mapImages/Markers/bikes/non-selected/bat_40.svg'
import bikeBat55 from '../../../assets/images/mapImages/Markers/bikes/non-selected/bat_55.svg'
import bikeBat90 from '../../../assets/images/mapImages/Markers/bikes/non-selected/bat_90.svg'
import bikeBat100 from '../../../assets/images/mapImages/Markers/bikes/non-selected/bat_100.svg'
// Bikes — selected (by battery)
import bikeSelectedBat10 from '../../../assets/images/mapImages/Markers/bikes/selected/bat_10.svg'
import bikeSelectedBat25 from '../../../assets/images/mapImages/Markers/bikes/selected/bat_25.svg'
import bikeSelectedBat40 from '../../../assets/images/mapImages/Markers/bikes/selected/bat_40.svg'
import bikeSelectedBat55 from '../../../assets/images/mapImages/Markers/bikes/selected/bat_55.svg'
import bikeSelectedBat90 from '../../../assets/images/mapImages/Markers/bikes/selected/bat_90.svg'
import bikeSelectedBat100 from '../../../assets/images/mapImages/Markers/bikes/selected/bat_100.svg'
// Bikes — reduced-price (using 15% as the default until API exposes a discount level)
import bikeDiscount from '../../../assets/images/mapImages/Markers/bikes/reduced-price/discount_15.svg'

// E-scooters — non-selected (by battery)
import escooterBat10 from '../../../assets/images/mapImages/Markers/e-scooters/non-selected/bat_10.svg'
import escooterBat25 from '../../../assets/images/mapImages/Markers/e-scooters/non-selected/bat_25.svg'
import escooterBat40 from '../../../assets/images/mapImages/Markers/e-scooters/non-selected/bat_40.svg'
import escooterBat55 from '../../../assets/images/mapImages/Markers/e-scooters/non-selected/bat_55.svg'
import escooterBat90 from '../../../assets/images/mapImages/Markers/e-scooters/non-selected/bat_90.svg'
import escooterBat100 from '../../../assets/images/mapImages/Markers/e-scooters/non-selected/bat_100.svg'
// E-scooters — selected (by battery)
import escooterSelectedBat10 from '../../../assets/images/mapImages/Markers/e-scooters/selected/bat_10.svg'
import escooterSelectedBat25 from '../../../assets/images/mapImages/Markers/e-scooters/selected/bat_25.svg'
import escooterSelectedBat40 from '../../../assets/images/mapImages/Markers/e-scooters/selected/bat_40.svg'
import escooterSelectedBat55 from '../../../assets/images/mapImages/Markers/e-scooters/selected/bat_55.svg'
import escooterSelectedBat90 from '../../../assets/images/mapImages/Markers/e-scooters/selected/bat_90.svg'
import escooterSelectedBat100 from '../../../assets/images/mapImages/Markers/e-scooters/selected/bat_100.svg'
// E-scooters — reduced-price (15% default — see note above)
import escooterDiscount from '../../../assets/images/mapImages/Markers/e-scooters/reduced-price/discount_15.svg'

// Cars
import carNonSelected from '../../../assets/images/mapImages/Markers/cars/non-selected/not_selected.svg'
import carSelected from '../../../assets/images/mapImages/Markers/cars/selected/selected.svg'
import carDiscount from '../../../assets/images/mapImages/Markers/cars/reduced-price/reduced_price.svg'

// Each group has its own intrinsic aspect ratio, so the addImage size is per-group.
// Pixel sizes below preserve the source SVG aspect ratios at a ~50–60 px visual height.
const markerGroups = [
  {
    width: 76,
    height: 50,
    images: [
      { name: 'bike_bat_10', url: bikeBat10 },
      { name: 'bike_bat_25', url: bikeBat25 },
      { name: 'bike_bat_40', url: bikeBat40 },
      { name: 'bike_bat_55', url: bikeBat55 },
      { name: 'bike_bat_90', url: bikeBat90 },
      { name: 'bike_bat_100', url: bikeBat100 },
      { name: 'bike_selected_bat_10', url: bikeSelectedBat10 },
      { name: 'bike_selected_bat_25', url: bikeSelectedBat25 },
      { name: 'bike_selected_bat_40', url: bikeSelectedBat40 },
      { name: 'bike_selected_bat_55', url: bikeSelectedBat55 },
      { name: 'bike_selected_bat_90', url: bikeSelectedBat90 },
      { name: 'bike_selected_bat_100', url: bikeSelectedBat100 },
      { name: 'bike_discount', url: bikeDiscount },
    ],
  },
  {
    width: 50,
    height: 50,
    images: [
      { name: 'escooter_bat_10', url: escooterBat10 },
      { name: 'escooter_bat_25', url: escooterBat25 },
      { name: 'escooter_bat_40', url: escooterBat40 },
      { name: 'escooter_bat_55', url: escooterBat55 },
      { name: 'escooter_bat_90', url: escooterBat90 },
      { name: 'escooter_bat_100', url: escooterBat100 },
      { name: 'escooter_selected_bat_10', url: escooterSelectedBat10 },
      { name: 'escooter_selected_bat_25', url: escooterSelectedBat25 },
      { name: 'escooter_selected_bat_40', url: escooterSelectedBat40 },
      { name: 'escooter_selected_bat_55', url: escooterSelectedBat55 },
      { name: 'escooter_selected_bat_90', url: escooterSelectedBat90 },
      { name: 'escooter_selected_bat_100', url: escooterSelectedBat100 },
      { name: 'escooter_discount', url: escooterDiscount },
    ],
  },
  {
    width: 33,
    height: 60,
    images: [
      { name: 'car_non_selected', url: carNonSelected },
      { name: 'car_selected', url: carSelected },
      { name: 'car_discount', url: carDiscount },
    ],
  },
]

function setVehicleImages(map, group) {
  group.images.forEach(image => {
    if (map.hasImage(image.name)) return
    const customIcon = new Image(group.width, group.height)
    customIcon.onload = () => {
      // Guard against double-add on hot reload / fast refresh.
      if (!map.hasImage(image.name)) {
        map.addImage(image.name, customIcon)
      }
      // Force the symbol layer to re-evaluate icon-image. The layer is created
      // synchronously while icon loads are async, so without this nudge Mapbox
      // can leave the layer rendering "nothing" even after the icon arrives.
      map.triggerRepaint()
    }
    customIcon.onerror = err => {
      console.warn(`[setVehiclesLayer] failed to load icon "${image.name}" from ${image.url}`, err)
    }
    customIcon.src = image.url
  })
}

// Mapbox expression: pick a "${prefix}_bat_N" icon based on battery percentage (0–100).
const batteryStep = prefix => [
  'step',
  ['*', ['coalesce', ['get', 'battery_pct'], 0], 100],
  `${prefix}_bat_10`,
  10, `${prefix}_bat_25`,
  25, `${prefix}_bat_40`,
  40, `${prefix}_bat_55`,
  55, `${prefix}_bat_90`,
  90, `${prefix}_bat_100`,
]

// Mapbox expression for bike/e-scooter: discount → battery bracket.
// NOTE: feature-state is intentionally NOT used here — Mapbox forbids it in
// layout properties like `icon-image`. To render a "selected" variant when a
// popup is open, the right approach is a second symbol layer overlaid on top
// with a `filter: ['boolean', ['feature-state', 'selected'], false]` (layer
// filters DO accept feature-state). Not wired up yet; tracked for later.
const twoWheelerIcon = (discountName, nonSelectedPrefix) => [
  'case',
  ['==', ['get', 'isDiscount'], true],
  discountName,
  batteryStep(nonSelectedPrefix),
]

// Intended to add vehicles on the map (source and layer)
export default function setVehiclesLayer(map, vehiclesData) {
  markerGroups.forEach(group => setVehicleImages(map, group))

  // promoteId surfaces properties.vehicle_id as the feature id so setFeatureState
  // (used in setMapMarkers to toggle the "selected" icon) can find each feature.
  map.addSource('vehiclesSource', {
    type: 'geojson',
    data: vehiclesData,
    cluster: false,
    promoteId: 'vehicle_id',
  })

  map.addLayer({
    id: 'vehiclesLayer',
    type: 'symbol',
    source: 'vehiclesSource',
    layout: {
      'icon-allow-overlap': true,
      'text-allow-overlap': true,
      'symbol-z-order': 'source',
      'icon-size': 0.9,
      'icon-image': [
        'case',
        // CAR — single image per state, no battery brackets
        ['==', ['get', 'vehicle_type'], 'CAR'],
        [
          'case',
          ['==', ['get', 'isDiscount'], true],
          'car_discount',
          'car_non_selected',
        ],
        // BIKE
        ['==', ['get', 'vehicle_type'], 'BIKE'],
        twoWheelerIcon('bike_discount', 'bike'),
        // default: SCOOTER (incl. electric) and any other type → e-scooter visuals
        twoWheelerIcon('escooter_discount', 'escooter'),
      ],
    },
    paint: {
      'icon-opacity': 1,
    },
  })
}
